import React from 'react'
import { Box } from "@mui/material"
import { AppLegendItem } from "@components"


export default function AnalyzersLegendToolbar({ isRating = false }) {
    const text = isRating ? "Rating" : "Price"
    const legend = [
        {
            icon: "droplet", label: `Cheapest ${text} in column`,
            iconProps: { color: "success.light", fontSize: 18 },
            containerProps: { border: "none" }
        },
        {
            icon: "droplet", label: `Most Expensive ${text} in column`,
            iconProps: { color: "error.light", fontSize: 18 },
            containerProps: { border: "none" }
        },
    ]

    return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', mb: 1, gap: 1 }}>
        {legend.map((item, idx) => <AppLegendItem key={idx} idx={idx} {...item}/>)}
    </Box>
}